import { Search } from "lucide-react";
import { Link } from "react-router";
import { ProfilKnopf } from "../design/Profil";
import { kopfDatum } from "./saetze";

/** Kopfzeile der Startseite (E14, DESIGN-W82 „Kopf mit Geist“): das Profil als Kürzel-Linse 44 (öffnet wie heute die
 *  Einstellungen, nur unter 744 px) und das Datum „**Freitag**, 16. Oktober“ (Wochentag betont, sonst Nebentext). */
export function Kopfzeile(props: { heute: string }) {
  const { tag, rest } = kopfDatum(props.heute);
  return (
    <span className="kopfzeile">
      <ProfilKnopf />
      <span className="kopf-datum w-nebentext" data-testid="kopf-datum">
        <b>{tag}</b>
        {rest}
      </span>
    </span>
  );
}

/** Lupe als runder Glasknopf rechts in der Kopfzeile (E14): Link zur Suche mit `role="search"` und dem Lesetext
 *  „Suchen“ wie bisher; der sichtbare Platzhaltertext entfällt. Nur unter 744 px (darüber sucht die Seitenleiste). */
export function Lupe() {
  return (
    <Link to="/suche" role="search" aria-label="Suchen" className="lupe glas">
      <Search size={20} strokeWidth={1.75} aria-hidden />
    </Link>
  );
}
